module.exports = __webpack_public_path__ + "img/img14.28c8aadf.jpg";